/* eslint-disable react/jsx-props-no-spreading */
import { useEffect, useState } from 'react'
import Head from 'next/head'
import { useRouter } from 'next/router'
import { GoogleTagManager } from '@next/third-parties/google'
import '../styles/globals.css'
import type { AppProps } from 'next/app'
import { ThemeProvider, createTheme } from '@mui/material/styles'
import { QueryClient, QueryClientProvider } from 'react-query'
import { LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import 'react-toastify/dist/ReactToastify.css'
import { NotificationBarStore } from '@itandi/itandi-bb-ui/NotificationBarStore'
import { Loader } from '@itandi/itandi-bb-ui/Loader'
import { ToastContainer } from 'react-toastify'
import { z } from 'zod'
import { zodCustomErrorMap } from '@hooks/zodCustomErrorMap'
import { Layout } from '../components/Layout'
import 'dayjs/locale/ja'
import 'remixicon/fonts/remixicon.css'

type withoutLayoutPageProps = {
  withoutLayout?: boolean
}

export const theme = createTheme()
const queryClient = new QueryClient()

z.setErrorMap(zodCustomErrorMap)

const App = ({ Component, pageProps }: AppProps<withoutLayoutPageProps>) => {
  const router = useRouter()

  const withoutLayout = pageProps?.withoutLayout ?? false

  const [display, setDisplay] = useState(false)
  useEffect(() => {
    if (router.isReady) {
      setDisplay(true)
    }
  }, [router.isReady])

  if (!display) {
    return <Loader />
  }

  return (
    <>
      <GoogleTagManager gtmId='GTM-WXJGP3PD' />
      <Head>
        <title>点検管理</title>
        <link href='https://brand-ui.itandi.app/favicons/tk.ico' rel='icon' />
      </Head>
      <ToastContainer
        autoClose={5000}
        closeOnClick
        draggable
        hideProgressBar={false}
        newestOnTop={false}
        pauseOnFocusLoss
        pauseOnHover
        position='top-right'
        rtl={false}
        theme='light'
      />
      <LocalizationProvider adapterLocale='ja' dateAdapter={AdapterDayjs}>
        <QueryClientProvider client={queryClient}>
          <ThemeProvider theme={theme}>
            {withoutLayout ? (
              <NotificationBarStore>
                <Component {...pageProps} />
              </NotificationBarStore>
            ) : (
              <Layout>
                <NotificationBarStore>
                  <Component {...pageProps} />
                </NotificationBarStore>
              </Layout>
            )}
          </ThemeProvider>
        </QueryClientProvider>
      </LocalizationProvider>
    </>
  )
}
/* eslint-disable-next-line import/no-default-export */
export default App
